import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { OperatorCalendarBuilder } from '../../models/builders/operator-calendar.builder';
import { OperatorDayChange } from '../../models/operator-calendar';
import { valueOf } from '../../utils/string.utils';

/** Las fechas de la ruta van en dd-MM-yyyy, como en el calendario general. */
export const OPERATOR_CALENDAR_DATE_FORMAT = 'DD-MM-YYYY';

@Injectable()
export class OperatorCalendarApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }working-model-groups`;
  }

  getCalendar(machineGroupHash: string, year: number) {
    const params = new HttpParams().append('year', valueOf(year));

    return this.httpClient.get(`${ this.apiUrl }/${ machineGroupHash }/operator-calendar`, { params })
      .pipe(
        map(OperatorCalendarBuilder.fromJson)
      );
  }

  getDay(machineGroupHash: string, day: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ machineGroupHash }/operator-calendar/${ day }`)
      .pipe(
        map(OperatorCalendarBuilder.fromJson)
      );
  }

  saveDay(machineGroupHash: string, day: string, operators: OperatorDayChange[]) {
    return this.httpClient.put(`${ this.apiUrl }/${ machineGroupHash }/operator-calendar/${ day }`, { operators })
      .pipe(
        map(OperatorCalendarBuilder.fromJson)
      );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/operator-calendar-api.service.ts